import { render } from "./LoadingScreen.vue?vue&type=template&id=250110c8"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=250110c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LoadingScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "250110c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('250110c8', __exports__)) {
    api.reload('250110c8', __exports__)
  }
  
  module.hot.accept("./LoadingScreen.vue?vue&type=template&id=250110c8", () => {
    api.rerender('250110c8', render)
  })

}


export default __exports__